import React from 'react';
import { Box, Typography } from '@mui/material';

const SectionHeader = ({ icon, title, bgColor = 'blue.50' }) => {
  return (
    <Box
      sx={{
        bgcolor: bgColor,
        px: 2,
        py: 1.5,
        borderBottom: 1,
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box sx={{ color: 'primary.main', mr: 1.5 }}>{icon}</Box>
      <Typography
        variant="h6"
        sx={{ color: 'grey.700', fontWeight: 600 }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default SectionHeader;